export default "__VITE_ASSET__CTXh_Yvt__"